import { CollapsibleSection } from "./CollapsibleSection";

interface SpouseToSpouseSectionProps {
  question: string;
  id?: string;
}

export const SpouseToSpouseSection = ({ question, id }: SpouseToSpouseSectionProps) => {
  const questions = question.split('|').map(q => q.trim());

  return (
    <CollapsibleSection title="Spouse to Spouse" highlightColor="bg-sage-100" id={id}>
      <div className="bg-sage-50 p-6 rounded-lg space-y-4">
        {questions.map((q, index) => (
          <p key={index} className="text-lg font-bold whitespace-pre-line text-center text-justify font-serif">
            {index + 1}. {q}
          </p>
        ))}
      </div>
    </CollapsibleSection>
  );
};